import React from 'react';

export function isPageLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : '';
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed|Unable to preload CSS/i.test(message);
}

type Props = { children: React.ReactNode };
type State = { error: Error | null };

/** Keep recovery independent of the router, store and theme that may have failed. */
export default class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[Admin page error]', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const loadError = isPageLoadError(this.state.error);
    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, boxSizing: 'border-box', background: '#f5f8f6', color: '#30383d', fontFamily: 'Prompt, sans-serif' }}>
        <section role="alert" aria-labelledby="page-error-title" style={{ width: '100%', maxWidth: 440, padding: 28, boxSizing: 'border-box', background: '#fff', border: '1px solid #dfe7e2', borderRadius: 12 }}>
          <h1 id="page-error-title" style={{ fontSize: 22, margin: '0 0 12px' }}>
            {loadError ? 'โหลดหน้านี้ไม่สำเร็จ' : 'เกิดข้อผิดพลาดในการแสดงผล'}
          </h1>
          <p style={{ lineHeight: 1.7, margin: '0 0 12px' }}>
            {loadError
              ? 'ไฟล์ของหน้านี้อาจมีการอัปเดต หรือการเชื่อมต่อขัดข้อง กรุณาโหลดหน้าใหม่เพื่อลองอีกครั้ง'
              : 'กรุณาโหลดหน้าใหม่เพื่อลองอีกครั้ง หากยังพบปัญหา โปรดแจ้งผู้ดูแลระบบพร้อมชื่อหน้าที่ใช้งาน'}
          </p>
          <p style={{ fontSize: 14, color: '#66716b', lineHeight: 1.7 }}>ข้อมูลที่ยังไม่ได้บันทึกอาจหายเมื่อโหลดใหม่</p>
          <button type="button" onClick={() => window.location.reload()} style={{ minHeight: 44, padding: '10px 24px', border: 0, borderRadius: 6, background: '#08a85b', color: '#fff', font: 'inherit', cursor: 'pointer' }}>
            โหลดหน้าใหม่
          </button>
        </section>
      </main>
    );
  }
}
